import { filter, map } from 'lodash';
import { v4 } from 'uuid';
import { CAMPAIGN_TYPE } from '../../../../config/constants';

export const CL_INIT_STATE = 'CL_INIT_STATE';
export const CL_SET_LOADING_STATE = 'CL_SET_LOADING_STATE';
export const CL_REMOVE_LOADING_STATE = 'CL_REMOVE_LOADING_STATE';

export const CL_SET_ACTIVE_STEP = 'CL_SET_ACTIVE_STEP';
export const CL_GOTO_NEXT_STEP = 'CL_GOTO_NEXT_STEP';
export const CL_GOTO_PREVIOUS_STEP = 'CL_GOTO_PREVIOUS_STEP';

export const CL_SELECT_ASIN = 'CL_SELECT_ASIN';
export const CL_UNSELECT_ASIN = 'CL_UNSELECT_ASIN';

export const CL_SELECT_CREATIVE = 'CL_SELECT_CREATIVE';
export const CL_UNSELECT_CREATIVE = 'CL_UNSELECT_CREATIVE';

export const CL_TOGGLE_TARGETING_STEP = 'CL_TOGGLE_TARGETING_STEP';
export const CL_TOGGLE_ASIN_GROUPING_STEP = 'CL_TOGGLE_ASIN_GROUPING_STEP';
export const CL_TOGGLE_CREATIVE_GROUPING_STEP = 'CL_TOGGLE_CREATIVE_GROUPING_STEP';
export const CL_SELECT_TEMPLATE_STEP = 'CL_SELECT_TEMPLATE_STEP';
export const CL_LOAD_CAMPAIGN_TEMPLATE = 'CL_LOAD_CAMPAIGN_TEMPLATE';
export const CL_UPDATE_CAMPAIGNS_BUDGET = 'CL_UPDATE_CAMPAIGNS_BUDGET';
export const CL_UPDATE_CAMPAIGN_SETTINGS = 'CL_UPDATE_CAMPAIGN_SETTINGS';
export const CL_SET_ACTIVE_CAMPAIGN = 'CL_SET_ACTIVE_CAMPAIGN';
export const CL_MAKE_ENABLE_CONTINUE = 'CL_MAKE_ENABLE_CONTINUE';

export const CL_SHOW_CAMPAIGN_NEGATIVE_KEYWORD = 'CL_SHOW_CAMPAIGN_NEGATIVE_KEYWORD';
export const CL_HIDE_CAMPAIGN_NEGATIVE_KEYWORD = 'CL_HIDE_CAMPAIGN_NEGATIVE_KEYWORD';
export const CL_REMOVE_CAMPAIGN_NEGATIVE_KEYWORD = 'CL_REMOVE_CAMPAIGN_NEGATIVE_KEYWORD';
export const CL_ADD_CAMPAIGN_NEGATIVE_KEYWORD = 'CL_ADD_CAMPAIGN_NEGATIVE_KEYWORD';

export const CL_SHOW_CAMPAIGN_NEGATIVE_TARGETS = 'CL_SHOW_CAMPAIGN_NEGATIVE_TARGETS';
export const CL_HIDE_CAMPAIGN_NEGATIVE_TARGETS = 'CL_HIDE_CAMPAIGN_NEGATIVE_TARGETS';

export const CL_SHOW_ADGROUP_NEGATIVE_KEYWORD = 'CL_SHOW_ADGROUP_NEGATIVE_KEYWORD';
export const CL_HIDE_ADGROUP_NEGATIVE_KEYWORD = 'CL_HIDE_ADGROUP_NEGATIVE_KEYWORD';

export const CL_ADD_CAMPAIGN_NEGATIVE_TARGET_KEYWORD = 'CL_ADD_CAMPAIGN_NEGATIVE_TARGET_KEYWORD';
export const CL_REMOVE_CAMPAIGN_NEGATIVE_TARGET_KEYWORD = 'CL_REMOVE_CAMPAIGN_NEGATIVE_TARGET_KEYWORD';

export const CL_ADD_ADGROUP_NEGATIVE_TARGETS = 'CL_ADD_ADGROUP_NEGATIVE_TARGETS';
export const CL_REMOVE_ADGROUP_NEGATIVE_TARGETS = 'CL_REMOVE_ADGROUP_NEGATIVE_TARGETS';

export const CL_ADD_ADGROUP_NEGATIVE_KEYWORDS = 'CL_ADD_ADGROUP_NEGATIVE_KEYWORDS';
export const CL_REMOVE_ADGROUP_NEGATIVE_KEYWORDS = 'CL_REMOVE_ADGROUP_NEGATIVE_KEYWORDS';

export const CL_ADD_ADGROUP_KEYWORDS = 'CL_ADD_ADGROUP_KEYWORDS';
export const CL_REMOVE_ADGROUP_KEYWORDS = 'CL_REMOVE_ADGROUP_KEYWORDS';

export const CL_ADD_ADGROUP_TARGETS = 'CL_ADD_ADGROUP_TARGETS';
export const CL_REMOVE_ADGROUP_TARGETS = 'CL_REMOVE_ADGROUP_TARGETS';

export const CL_UPDATE_EMPTY_CAMPAIGN = 'CL_UPDATE_EMPTY_CAMPAIGN';

export const CL_UPDATE_ADGROUP_AUTO_TARGETS = 'CL_UPDATE_ADGROUP_AUTO_TARGETS';
export const CL_UPDATE_ADGROUP_AUTO_TARGET_BID = 'CL_UPDATE_ADGROUP_AUTO_TARGET_BID';

export const CL_UPDATE_ADGROUP_SP_AUTO_DEFAULT_BID = 'CL_UPDATE_ADGROUP_SP_AUTO_DEFAULT_BID';

export const CL_UPDATE_ADGROUP_NAME = 'CL_UPDATE_ADGROUP_NAME';

export const campaignLauncherInit = (type) => ({ type: CL_INIT_STATE, payload: type });

export const setLoadingAction = () => ({ type: CL_SET_LOADING_STATE });

export const removeLoadingAction = () => ({ type: CL_REMOVE_LOADING_STATE });

export const loadCampaignTemplateAction = (campaigns) => ({ type: CL_LOAD_CAMPAIGN_TEMPLATE, payload: campaigns });

export const setActiveSetAction = (activeStep) => ({
  type: CL_SET_ACTIVE_STEP,
  payload: activeStep,
});

export const selectAsinAction = (asin) => ({
  type: CL_SELECT_ASIN,
  payload: asin,
});

export const unselectAsinAction = (asin) => ({
  type: CL_UNSELECT_ASIN,
  payload: asin,
});

export const selectCreativeAction = (creativeIds) => ({
  type: CL_SELECT_CREATIVE,
  payload: creativeIds,
});

export const unselectCreativeAction = (creativeIds) => ({
  type: CL_UNSELECT_CREATIVE,
  payload: creativeIds,
});

export const continueToNextStepAction = () => ({
  type: CL_GOTO_NEXT_STEP,
});

export const goToPreviousStepAction = () => ({
  type: CL_GOTO_PREVIOUS_STEP,
});

export const toggleTargetingAction = (isSelected, targeting) => ({
  type: CL_TOGGLE_TARGETING_STEP,
  payload: targeting,
  isSelected,
});

export const setActiveCampaignAction = (campaignId) => ({
  type: CL_SET_ACTIVE_CAMPAIGN,
  payload: campaignId,
});

export const makeEnableContinueButton = (canContinue) => ({
  type: CL_MAKE_ENABLE_CONTINUE,
  payload: canContinue,
});

export const updateCLCampaignBudget = (payload) => ({
  type: CL_UPDATE_CAMPAIGNS_BUDGET,
  payload,
});

export const updateCLCampaignSettings = (campaignId, values) => ({
  type: CL_UPDATE_CAMPAIGN_SETTINGS,
  payload: {
    campaignId,
    values,
  },
});

export const showCampaignNegativeKeywords = (campaignId) => ({
  type: CL_SHOW_CAMPAIGN_NEGATIVE_KEYWORD,
  payload: campaignId,
});

export const hideCampaignNegativeKeywords = () => ({
  type: CL_HIDE_CAMPAIGN_NEGATIVE_KEYWORD,
});

export const showCampaignNegativeTargets = (campaignId) => ({
  type: CL_SHOW_CAMPAIGN_NEGATIVE_TARGETS,
  payload: campaignId,
});

export const hideCampaignNegativeTargets = () => ({
  type: CL_HIDE_CAMPAIGN_NEGATIVE_TARGETS,
});

export const showAdGroupNegativeKeywords = (campaignId) => ({
  type: CL_SHOW_ADGROUP_NEGATIVE_KEYWORD,
  payload: campaignId,
});

export const hideAdGroupNegativeKeywords = () => ({
  type: CL_HIDE_ADGROUP_NEGATIVE_KEYWORD,
});

export const addCampaignNegativeKeyword = (campaignId, payload) => ({
  type: CL_ADD_CAMPAIGN_NEGATIVE_KEYWORD,
  payload: {
    campaignId,
    ...payload,
  },
});

export const addCampaignNegativeTargetKeywords = (campaignId, targets) => ({
  type: CL_ADD_CAMPAIGN_NEGATIVE_TARGET_KEYWORD,
  payload: {
    campaignId,
    targets,
  },
});

export const removeCampaignNegativeTargetKeywords = (campaignId, targetIds) => ({
  type: CL_REMOVE_CAMPAIGN_NEGATIVE_TARGET_KEYWORD,
  payload: {
    campaignId,
    targetIds,
  },
});

export const removeCampaignNegativeKeyword = (campaignId, negativeKeywordIds) => ({
  type: CL_REMOVE_CAMPAIGN_NEGATIVE_KEYWORD,
  payload: {
    campaignId,
    negativeKeywordIds,
  },
});

export const adGroupLuncherNegativeTargets = (campaignId, adGroupId, targets) => ({
  type: CL_ADD_ADGROUP_NEGATIVE_TARGETS,
  payload: {
    campaignId,
    adGroupId,
    targets,
  },
});

export const removeGroupLuncherNegativeTargets = (campaignId, adGroupId, targetIds) => ({
  type: CL_REMOVE_ADGROUP_NEGATIVE_TARGETS,
  payload: {
    campaignId,
    adGroupId,
    targetIds,
  },
});

export const adGroupLuncherNegativeKeywords = (campaignId, adGroupId, payload) => ({
  type: CL_ADD_ADGROUP_NEGATIVE_KEYWORDS,
  payload: {
    campaignId,
    adGroupId,
    ...payload,
  },
});

export const removeAdGroupLuncherNegativeKeywords = (campaignId, adGroupId, keywordsId) => ({
  type: CL_REMOVE_ADGROUP_NEGATIVE_KEYWORDS,
  payload: {
    campaignId,
    adGroupId,
    keywordsId,
  },
});

export const addAdGroupLuncherKeywords = (campaignId, adGroupId, keywords) => ({
  type: CL_ADD_ADGROUP_KEYWORDS,
  payload: {
    campaignId,
    adGroupId,
    keywords,
  },
});

export const removeAdGroupLuncherKeyword = (campaignId, adGroupId, keywordIds) => ({
  type: CL_REMOVE_ADGROUP_KEYWORDS,
  payload: {
    campaignId,
    adGroupId,
    keywordIds,
  },
});

export const addAdGroupLuncherTarget = (campaignId, adGroupId, targets) => ({
  type: CL_ADD_ADGROUP_TARGETS,
  payload: {
    campaignId,
    adGroupId,
    targets,
  },
});

export const removeAdGroupLuncherTarget = (campaignId, adGroupId, targetIds) => ({
  type: CL_REMOVE_ADGROUP_TARGETS,
  payload: {
    campaignId,
    adGroupId,
    targetIds,
  },
});

export const updateEmptyCampaignLuncher = (campaignId, emptyCampaign) => ({
  type: CL_UPDATE_EMPTY_CAMPAIGN,
  payload: {
    campaignId,
    emptyCampaign,
  },
});

export const updateAdGroupAutoTarget = (campaignId, adGroupId, targetId, enabled) => ({
  type: CL_UPDATE_ADGROUP_AUTO_TARGETS,
  payload: {
    campaignId,
    adGroupId,
    targetId,
    enabled,
  },
});

export const updateAdGroupAutoTargetBid = (campaignId, adGroupId, targetId, bid) => ({
  type: CL_UPDATE_ADGROUP_AUTO_TARGET_BID,
  payload: {
    campaignId,
    adGroupId,
    targetId,
    bid,
  },
});

export const updateCampaignAdGroupDefaultBid = (campaignId, adGroupId, defaultBid) => ({
  type: CL_UPDATE_ADGROUP_SP_AUTO_DEFAULT_BID,
  payload: {
    campaignId,
    adGroupId,
    defaultBid,
  },
});

export const updateCampaignAdGroupName = (campaignId, adGroupId, name) => ({
  type: CL_UPDATE_ADGROUP_NAME,
  payload: {
    campaignId,
    adGroupId,
    name,
  },
});

export const toggleAsinGroupingAction = () => ({ type: CL_TOGGLE_ASIN_GROUPING_STEP });

export const toggleCreativeGroupingAction = () => ({ type: CL_TOGGLE_CREATIVE_GROUPING_STEP });

export const selectTemplateAction = (template) => ({ type: CL_SELECT_TEMPLATE_STEP, payload: template });

const validateAdGroups = (adGroup, skipValidate = false) => {
  let valid = false;
  if (skipValidate) {
    valid = true;
  } else if (adGroup.type === 'SP_AUTO') {
    valid = filter(adGroup.targets, (i) => i.enabled).length > 0;
  } else if (['phrase', 'exact', 'broad'].includes(adGroup.matchType)) {
    valid = adGroup.keywords?.length > 0;
  } else {
    valid = adGroup.targets?.length > 0;
  }
  if (adGroup.type.indexOf('SP') === 0) {
    adGroup?.ads?.length > 0;
  }
  return {
    ...adGroup,
    valid: adGroup?.settings?.name && adGroup?.settings?.defaultBid && valid,
  };
};

const validateCampaigns = (campaigns) => {
  return map(campaigns, (campaign) => {
    const adGroups = map(campaign.adGroups, (i) => validateAdGroups(i, campaign.emptyCampaign));
    const validAdGroups = adGroups.every((i) => i.valid);
    const validCampaign = campaign.settings?.name && campaign.settings?.budget && campaign.settings?.startDate;
    return { ...campaign, adGroups, valid: validAdGroups && validCampaign };
  });
};

const updateCampaignSettings = (type, campaigns, action) => {
  return map(campaigns, (i) => {
    if (i.id === action.payload.campaignId) {
      const campaign = {
        ...i,
        settings: {
          ...i.settings,
          startDate: action.payload.values.startDate,
          endDate: action.payload.values.endDate,
          budget: action.payload.values.budget,
          name: action.payload.values.name,
        },
      };

      if (type === CAMPAIGN_TYPE.SP) {
        const placementBidding = [];
        if (action.payload.values?.placementTopOfSearch > 0) {
          placementBidding.push({ placement: 'PLACEMENT_TOP', percentage: action.payload.values?.placementTopOfSearch });
        }
        if (action.payload.values?.placementProductPages > 0) {
          placementBidding.push({
            placement: 'PLACEMENT_PRODUCT_PAGE',
            percentage: action.payload.values?.placementProductPages,
          });
        }
        if (action.payload.values?.placementRestOfSearch > 0) {
          placementBidding.push({
            placement: 'PLACEMENT_REST_OF_SEARCH',
            percentage: action.payload.values?.placementRestOfSearch,
          });
        }

        campaign.settings.bidding = {
          strategy: action.payload.values.biddingStrategy,
          placementBidding: placementBidding,
        };
      } else if (type === CAMPAIGN_TYPE.SB) {
        campaign.settings.bidding = {
          goals: action.payload?.values?.goals,
          bidOptimization: action.payload?.values?.bidOptimization,
          bidPlacement: action.payload?.values?.bidPlacement,
        };
      } else if (type === CAMPAIGN_TYPE.SD) {
        campaign.optimisationStrategy = action.payload?.values.optimisationStrategy;
      }
      return campaign;
    }
    return i;
  });
};

const init = {
  campaignType: CAMPAIGN_TYPE.SP,
  activeStep: 0,
  targeting: [],
  isAsinGrouped: false,
  isCreativeGrouped: false,
  canContinue: false,
  templateId: null,
  campaigns: [],
  asinSelector: 'asin',
  asins: [],
  creativeIds: [],
  loading: false,
  activeCampaign: null,
  showCNKeywords: null,
  showCNTargets: null,
  showAGNKeywords: null,
  showAGNTargets: null,
};

export default (state = init, action) => {
  let newState = { ...state };

  switch (action.type) {
    case CL_INIT_STATE:
      newState = { ...init, campaignType: action.payload };
      if (action.payload === CAMPAIGN_TYPE.SP) {
        newState.targeting = ['auto', 'phrase', 'exact', 'product'];
      } else if (action.payload === CAMPAIGN_TYPE.SB) {
        newState.targeting = ['phrase', 'exact', 'product'];
      } else if (action.payload === CAMPAIGN_TYPE.SD) {
        newState.targeting = ['contextual'];
      }
      break;
    case CL_SET_LOADING_STATE:
      newState.loading = true;
      break;
    case CL_REMOVE_LOADING_STATE:
      newState.loading = false;
      break;

    case CL_SET_ACTIVE_STEP:
      newState.activeStep = action.payload;
      break;
    case CL_GOTO_PREVIOUS_STEP:
      if (newState.activeStep === 1) {
        newState.activeCampaign = null;
      }
      newState.activeStep -= 1;
      newState.canContinue = false;
      break;
    case CL_GOTO_NEXT_STEP:
      if (newState.activeStep === 1) {
        newState.activeCampaign = null;
      }
      newState.activeStep += 1;
      newState.canContinue = false;
      break;

    // step 1 select asin/creative
    case CL_SELECT_ASIN:
      newState.asinSelector = 'asin';
      newState.creativeIds = [];
      newState.asins = [...newState.asins, ...action.payload];
      newState.canContinue = newState.asins.length > 0;
      break;

    case CL_UNSELECT_ASIN:
      newState.asins = filter(newState.asins, (i) => !action.payload.includes(i));
      newState.canContinue = newState.asins.length > 0;
      break;

    case CL_SELECT_CREATIVE:
      newState.asinSelector = 'creative';
      newState.asins = [];
      newState.creativeIds = [...newState.creativeIds, ...action.payload];
      newState.canContinue = newState.creativeIds.length > 0;
      break;

    case CL_UNSELECT_CREATIVE:
      newState.creativeIds = filter(newState.creativeIds, (i) => !action.payload.includes(i));
      newState.canContinue = newState.creativeIds.length > 0;
      break;

    // step 2 select targeting and template
    case CL_TOGGLE_TARGETING_STEP:
      {
        const { isSelected } = action;
        if (isSelected) {
          newState.targeting = [...newState.targeting, action.payload];
        } else {
          newState.targeting = filter(newState.targeting, (i) => i !== action.payload);
          if (newState.targeting.length === 0) {
            newState.canContinue = false;
            newState.templateId = null;
          }
        }
      }
      break;
    case CL_TOGGLE_ASIN_GROUPING_STEP:
      newState.isAsinGrouped = !newState.isAsinGrouped;
      break;
    case CL_TOGGLE_CREATIVE_GROUPING_STEP:
      newState.isCreativeGrouped = !newState.isCreativeGrouped;
      break;
    case CL_SELECT_TEMPLATE_STEP:
      newState.canContinue = true;
      newState.templateId = action.payload;
      break;

    case CL_LOAD_CAMPAIGN_TEMPLATE:
      newState.activeStep = 2;
      newState.canContinue = false;
      newState.loading = false;
      newState.campaigns = validateCampaigns(action.payload);
      break;

    case CL_SET_ACTIVE_CAMPAIGN:
      newState.activeCampaign = action.payload;
      break;

    case CL_MAKE_ENABLE_CONTINUE:
      newState.canContinue = action.payload;
      break;

    case CL_UPDATE_CAMPAIGNS_BUDGET:
      newState.campaigns = map(state.campaigns, (i) => ({
        ...i,
        settings: { ...i.settings, budget: Number(action.payload) },
      }));
      newState.campaigns = validateCampaigns(newState.campaigns);
      break;

    case CL_UPDATE_CAMPAIGN_SETTINGS:
      newState.campaigns = validateCampaigns(updateCampaignSettings(newState.campaignType, state.campaigns, action));
      break;

    case CL_ADD_CAMPAIGN_NEGATIVE_KEYWORD:
      newState.campaigns = validateCampaigns(
        map(state.campaigns, (campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              negativeKeywords: [
                ...map(action.payload.keywords, (i) => ({ id: v4(), keyword: i, matchType: action.payload.matchType })),
                ...campaign.negativeKeywords,
              ],
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_REMOVE_CAMPAIGN_NEGATIVE_KEYWORD:
      newState.campaigns = map(newState.campaigns, (campaign) => {
        if (campaign.id === action.payload.campaignId) {
          return {
            ...campaign,
            negativeKeywords: filter(campaign?.negativeKeywords, (i) => !action.payload.negativeKeywordIds.includes(i.id)),
          };
        }
        return campaign;
      });
      break;

    case CL_ADD_CAMPAIGN_NEGATIVE_TARGET_KEYWORD:
      newState.campaigns = validateCampaigns(
        map(state?.campaigns, (campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              negativeTargets: [
                ...map(action.payload.targets, (i) => ({
                  id: v4(),
                  resolvedExpression: JSON.stringify([{ type: 'asinSameAs', value: i }]),
                })),
                ...campaign.negativeTargets,
              ],
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_SHOW_CAMPAIGN_NEGATIVE_KEYWORD:
      newState.showCNKeywords = action.payload;
      break;

    case CL_HIDE_CAMPAIGN_NEGATIVE_KEYWORD:
      newState.showCNKeywords = null;
      break;

    case CL_SHOW_CAMPAIGN_NEGATIVE_TARGETS:
      newState.showCNTargets = action.payload;
      break;

    case CL_HIDE_CAMPAIGN_NEGATIVE_TARGETS:
      newState.showCNTargets = null;
      break;

    case CL_SHOW_ADGROUP_NEGATIVE_KEYWORD:
      newState.showAGNKeywords = action.payload;
      break;

    case CL_HIDE_ADGROUP_NEGATIVE_KEYWORD:
      newState.showAGNKeywords = null;
      break;

    case CL_REMOVE_CAMPAIGN_NEGATIVE_TARGET_KEYWORD:
      newState.campaigns = validateCampaigns(
        map(state?.campaigns, (campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              negativeTargets: campaign?.negativeTargets?.filter((target) => !action.payload?.targetIds.includes(target.id)),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_ADD_ADGROUP_NEGATIVE_TARGETS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    negativeTargets: [
                      ...adgroup.negativeTargets,
                      ...map(action.payload.targets, (i) => ({
                        id: v4(),
                        resolvedExpression: JSON.stringify([{ type: 'asinSameAs', value: i }]),
                      })),
                    ],
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_REMOVE_ADGROUP_NEGATIVE_TARGETS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    negativeTargets: adgroup?.negativeTargets?.filter(
                      (keyword) => !action.payload?.targetIds?.includes(keyword.id),
                    ),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_ADD_ADGROUP_NEGATIVE_KEYWORDS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    negativeKeywords: [
                      ...campaign.negativeKeywords,
                      ...map(action?.payload?.keywords, (i) => ({
                        id: v4(),
                        keywordText: i,
                        matchType: action?.payload?.matchType,
                      })),
                    ],
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_REMOVE_ADGROUP_NEGATIVE_KEYWORDS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    negativeKeywords: adgroup?.negativeKeywords?.filter(
                      (keyword) => !action.payload?.keywordsId?.includes(keyword.id),
                    ),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_ADD_ADGROUP_KEYWORDS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    keywords: [...(adgroup?.keywords || []), ...action.payload.keywords],
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_REMOVE_ADGROUP_KEYWORDS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    keywords: adgroup?.keywords?.filter((keyword) => !action.payload?.keywordIds?.includes(keyword._id)),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_ADD_ADGROUP_TARGETS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    targets: [...(adgroup?.targets || []), ...action.payload.targets],
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_REMOVE_ADGROUP_TARGETS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    targets: adgroup?.targets?.filter((target) => !action.payload?.targetIds?.includes(target._id)),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;
    case CL_UPDATE_EMPTY_CAMPAIGN:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              emptyCampaign: action.payload.emptyCampaign,
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_UPDATE_ADGROUP_AUTO_TARGETS:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    targets: adgroup?.targets?.map((target) => {
                      if (target.id === action?.payload?.targetId) {
                        return {
                          ...target,
                          enabled: action.payload.enabled,
                        };
                      }
                      return target;
                    }),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_UPDATE_ADGROUP_AUTO_TARGET_BID:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup.id === action.payload.adGroupId) {
                  return {
                    ...adgroup,
                    targets: adgroup?.targets?.map((target) => {
                      if (target.id === action?.payload?.targetId) {
                        return {
                          ...target,
                          bid: action.payload.bid,
                        };
                      }
                      return target;
                    }),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_UPDATE_ADGROUP_SP_AUTO_DEFAULT_BID:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    defaultBid: Number(action?.payload?.defaultBid),
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    case CL_UPDATE_ADGROUP_NAME:
      newState.campaigns = validateCampaigns(
        state.campaigns.map((campaign) => {
          if (campaign.id === action.payload.campaignId) {
            return {
              ...campaign,
              adGroups: campaign.adGroups.map((adgroup) => {
                if (adgroup?.id === action?.payload?.adGroupId) {
                  return {
                    ...adgroup,
                    settings: {
                      ...adgroup.settings,
                      name: action.payload.name,
                    },
                  };
                }
                return adgroup;
              }),
            };
          }
          return campaign;
        }),
      );
      break;

    default:
  }
  return newState;
};
